import { IApplicationState } from '../../types/redux';

export const selectReferenceLink = (state: IApplicationState) => state.referenceLink;
